// extracted by mini-css-extract-plugin
module.exports = {"stickyFooter":"stickyFooter_stickyFooter__2mxUX","footerContent":"stickyFooter_footerContent__1zDcd"};